import React from 'react';
import { useSelector } from 'react-redux';
import { importeConComa } from '../../../helpers/cobroDatafono';

/** Textos cuando se cancela la cita entera (también el último o único servicio y el no-show). */
const COPY_CITA = {
    titulo: 'Penalización por cancelación',
    pregunta: (importe) => `¿Quieres penalizar al usuario marcando como no presentado y descontándole el importe de ${importe} del monedero? ¿O quieres cancelar la cita sin penalización?`,
    avisoSinSaldo: 'El cliente no tiene saldo en el monedero, así que no hay saldo que descontar: si penalizas, la cita solo se marcará como no presentada.',
    botonSinPenalizar: 'No, solo cancelar'
};

/** Textos cuando se anula un servicio de una cita que sigue con otros: la cita no cambia de estado. */
const COPY_SERVICIO = {
    titulo: 'Penalización por anulación de servicio',
    pregunta: (importe) => `¿Quieres penalizar al usuario descontándole el importe de ${importe} del monedero por este servicio? ¿O quieres anular el servicio sin penalización?`,
    avisoSinSaldo: 'El cliente no tiene saldo en el monedero, así que no hay saldo que descontar: si penalizas, no se descontará nada y el servicio se anulará.',
    botonSinPenalizar: 'No, solo anular el servicio'
};

/**
 * Pregunta si se penaliza al cliente cuando la cancelación cae en periodo de penalización
 * (fuera de plazo o no presentado). Se pinta dentro del `.modal-wrapper` de `ModalDeleteCita`.
 * `importe` e `importeDescontar` llegan en euros desde `GET citas/:id/penalizacion`.
 * `anulaServicio` indica que solo se anula un servicio de una cita que sigue con otros.
 */
export const ModalPenalizacionCita = ({ penalizacion, anulaServicio = false, onPenalizar, onSoloCancelar, onCerrar }) => {
    const { colores } = useSelector(state => state.ui);
    const { importe, saldo, importeDescontar } = penalizacion;
    const copy = anulaServicio ? COPY_SERVICIO : COPY_CITA;

    // Con importe 0 tampoco se descuenta nada, pero el aviso solo dice la verdad si el monedero está vacío.
    const monederoSinSaldo = !(saldo > 0);
    const sinSaldoQueDescontar = importeDescontar === 0 && monederoSinSaldo;
    const saldoNoCubreImporte = importeDescontar > 0 && importeDescontar < importe;

    return (
        <>
            <div className="modal-title">
                <h3 style={{ color: colores.colorSecundario }}>{copy.titulo}</h3>
            </div>
            <div className="modal-body">
                <p>{copy.pregunta(importeConComa(importeDescontar))}</p>
                {sinSaldoQueDescontar && (
                    <p className="modal-gestion__aviso">{copy.avisoSinSaldo}</p>
                )}
                {saldoNoCubreImporte && (
                    <p className="modal-gestion__aviso">
                        El saldo del monedero no cubre el importe completo ({importeConComa(importe)}): solo
                        se descontará lo disponible.
                    </p>
                )}
            </div>
            <div className="modal-footer">
                <div className="buttons buttons--decision">
                    <div
                        className="btn btn-confirm"
                        style={{ backgroundColor: colores.colorPrincipal }}
                        onClick={onPenalizar}
                    >Sí, penalizar</div>
                    <div
                        className="btn btn-confirm"
                        style={{ backgroundColor: colores.colorPrincipal }}
                        onClick={onSoloCancelar}
                    >{copy.botonSinPenalizar}</div>
                    <div
                        className="btn btn-cancel"
                        onClick={onCerrar}
                    >Cerrar</div>
                </div>
            </div>
        </>
    );
};
